<template>
  <div class="vx-card" id="agent-recipient-info">
    <div class="vx-card__body card-body">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div
            class="recipient-list transferee-options"
            v-for="(recipient, index) in recipients"
            :key="index"
          >
            <div class="w-full recipient-item" v-if="refresh">
              <div class="wrapper">
                <span class="ttl w-full">
                  <strong>تحویل گیرنده: </strong>
                  <span> {{ recipient.fullName }} </span>
                </span>
                <span class="w-full">
                  <strong>آدرس: </strong>
                  <span>
                    {{ recipient.addressInfo.province.name }}-{{
                      recipient.addressInfo.province.cityName
                    }}-{{ recipient.addressInfo.address }}-<strong
                      >کدپستی:</strong
                    >
                    {{ recipient.addressInfo.postalCode }}
                  </span>
                </span>
                <span class="w-full">
                  <strong> شماره تلفن: </strong>
                  <span>{{ recipient.phoneNumber }}</span>
                  <strong> شماره موبایل: </strong>
                  <span>{{ recipient.mobileNumber }}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row mt-6" v-if="!addNewInfo && recipients.length == 0">
        <div class="vx-col w-full">
          <div class="no-info">اطلاعات تحویل گیرنده وارد نشده است!</div>
        </div>
      </div>
      <div class="loadingsec" v-if="showLoading">
        <svg
          class="spinner"
          width="65px"
          height="65px"
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            class="path"
            fill="none"
            stroke-width="6"
            stroke-linecap="round"
            cx="33"
            cy="33"
            r="30"
          ></circle>
        </svg>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.vs-con-textarea h4 {
  margin-bottom: 0.25rem !important;
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "vue-select";
import RecipientModifyPopup from "./RecipientModifyPopup.vue";
const dict = {
};
Validator.localize("fa", dict);
export default {
  data() {
    return {
      // permission85: "",
      addNewInfo: false,
      disabled: false,
      cityDisable: true,
      recipientModel: {},
      ownerUserName: "",
      ownerUserId: null,
      showLoading: false,
      recipients: [],
      refresh: true,
      Ids: {},
    };
  },
  computed: {
    ...mapGetters({
      allProvinces: "country/provinceList",
      allCities: "country/cityList",
      agnet: "parties/agentDetails",
      mainRecipients: "recipientsShipping/agentRecipients",
    }),
  },
  mounted() {
    this.fetchProvinces();
    this.load();
  },
  methods: {
    ...mapActions({
      fetchProvinces: "country/fetchProvinces",
      fetchCitiesById: "country/fetchCitiesById",
      fetchSingleAgent: "parties/fetchSingleAgent",
      fetchAgentRecipients: "recipientsShipping/fetchAgentRecipients",
    }),
    load() {
      this.showLoading = true;
      // var id = this.$route.params.id;
      // this.fetchSingleAgent(id).then(() => {
      //   this.model.ownerUserId = this.agnet.agentOwnerQuery.ownerId;
      //   this.model.ownerUserName = this.agnet.agentOwnerQuery.agentOwnerName;
      //   this.Ids.ownerUserId = this.agnet.agentOwnerQuery.ownerId;
      //   this.Ids.agentId = this.agnet.id;
      this.Ids.ownerUserId = this.$route.query.ownerUserId;
      this.Ids.agentId = this.$route.params.id;
      this.fetchAgentRecipients(this.Ids).then(() => {
        this.recipients = this.mainRecipients;
        this.showLoading = false;
      });
      // });
    },

  },
  components: {
    "v-select": vSelect,
    RecipientModifyPopup,
  },
};
</script>
